var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95025 15.7582H3.89051L2.34596 9.69237C2.27264 9.41334 2.11698 9.16667 1.88801 9.0504C1.31659 8.75823 0.686915 8.5257 0 8.40843V8.1749H3.31808C3.77602 8.1749 4.11948 8.5257 4.17672 8.93313L4.97813 13.3086L7.03686 8.1749H9.03936L5.95025 15.7582ZM10.1842 15.7582H8.23897L9.84077 8.1749H11.786L10.1842 15.7582ZM14.3027 10.2757C14.3599 9.86728 14.7034 9.63374 15.1041 9.63374C15.7338 9.57511 16.4197 9.69238 16.9921 9.98354L17.3356 8.35081C16.7631 8.11727 16.1335 8 15.562 8C13.674 8 12.3002 9.05041 12.3002 10.5082C12.3002 11.6173 13.2733 12.1996 13.9602 12.5504C14.7034 12.9002 14.9896 13.1338 14.9324 13.4835C14.9324 14.0082 14.3599 14.2418 13.7885 14.2418C13.1016 14.2418 12.4147 14.0669 11.786 13.7747L11.4426 15.4085C12.1295 15.6996 12.8726 15.8169 13.5595 15.8169C15.6765 15.8745 16.9921 14.8251 16.9921 13.25C16.9921 11.2665 14.3027 11.1502 14.3027 10.2757ZM23.8 15.7582L22.2554 8.1749H20.5964C20.2529 8.1749 19.9095 8.40843 19.795 8.75823L16.9349 15.7582H18.9374L19.3371 14.6502H21.7975L22.0265 15.7582H23.8ZM20.8826 10.2171L21.454 13.0751H19.8523L20.8826 10.2171Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.dd916cd563d2e8ef26b69c74ad8ab4ad.svg";
export { ForwardRef as ReactComponent };